/**
 * @generated SignedSource<<92431dff31ff5242ff80d36cd7a0584b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteProjectInput = {
  id: string;
};
export type DeleteProjectDialogMutation$variables = {
  input: DeleteProjectInput;
};
export type DeleteProjectDialogMutation$data = {
  readonly deleteProject: {
    readonly id: string;
  };
};
export type DeleteProjectDialogMutation = {
  response: DeleteProjectDialogMutation$data;
  variables: DeleteProjectDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProjectDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteProject",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProjectDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be69704082e3c0688a902edb3bcd1f16",
    "id": null,
    "metadata": {},
    "name": "DeleteProjectDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProjectDialogMutation(\n  $input: DeleteProjectInput!\n) {\n  deleteProject(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "58cc6b058e5426f0f5254363bc03691d";

export default node;
